import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import FormLabel from '@material-ui/core/FormLabel';

// HELP
import CreditCardForm from './CreditCardForm';
import CreditCardPlaceholder from './CreditCardPlaceholder';

// STYLES
import { StyledCreditCard } from './styles';

export const CardMode = {
  form: 'form',
  placeholder: 'placeholder',
};

function CreditCard({ defaultCard, values, setFieldValue, ...props }) {
  const [t] = useTranslation();

  const showForm = values.cardMode === CardMode.form;
  const isChange = showForm && Boolean(defaultCard);

  function onChangeCard() {
    setFieldValue('cardMode', CardMode.form);
  }

  function onCancelChangeCard() {
    setFieldValue('cardMode', CardMode.placeholder);
  }

  return (
    <StyledCreditCard className="credit-card">
      <FormLabel component="legend" className="p4 credit-card__label">
        {t('inputs.creditCard')}
      </FormLabel>
      {showForm ? (
        <CreditCardForm
          {...props}
          setFieldValue={setFieldValue}
          values={values}
          isChange={isChange}
          onCancelChangeCard={onCancelChangeCard}
        />
      ) : (
        <CreditCardPlaceholder data={defaultCard} onChangeCard={onChangeCard} />
      )}
    </StyledCreditCard>
  );
}

CreditCard.propTypes = {
  setFieldValue: PropTypes.func.isRequired,
  setFieldTouched: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
  touched: PropTypes.object.isRequired,
  values: PropTypes.object.isRequired,
  defaultCard: PropTypes.object,
};

export default React.memo(CreditCard);
